import * as R from 'ramda'

/**
 * Get all notification IDs.
 *
 * @param {Object} state
 * @returns {Array<Notification>} list of notification ids
 */
export function getAll(state) {
  return R.reject(R.isNil, R.pluck('id', state))
}

/**
 * Get notification.
 *
 * @param {Object} state
 * @param {Object} props
 * @param {string} props.id Notification ID
 * @returns {Notification} notification by id
 */
export function getOne(state, props) {
  return state[props.id]
}
